import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ConservationMethodology } from '@/api/rest/resources/conservation';
import {
  EcologicalIntegrityExplainerBU,
  EcologicalIntegrityExplainerVNU,
} from '@/components/NCExplainers/EcologicalIntegrityExplainer';
import { ExplainerTrigger } from '@/components/NCExplainers/Explainer';
import { RestorationLandMonitoringExplainer } from '@/components/NCExplainers/RestorationLandMonitoringExplainer';
import { CarbonTile } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/components/CarbonTile';
import { NDVITile } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/components/NDVITile';
import { WaterTile } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/components/WaterTile';
import { useIsRestorationProject } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/hooks/useIsRestorationProject';
import { useProject } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useProject';

import { HabitatIntactnessCard } from './components/HabitatIntactnessCard';
import { IndicatorSpeciesCard } from './components/IndicatorSpeciesCard';

export const LandMonitoringPage = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={8}>
      <Stack direction='row' centerMain className='justify-between'>
        <span className='typography-overline'>
          {t('shared.ncaDetail.details.landMonitoring.ecologicalIntegrityIndicators')}
        </span>
        <div className='hidden md:[display:_initial]'>
          <LandMonitoringExplainer />
        </div>
      </Stack>
      <LandMonitoringCards />
    </Stack>
  );
};

const LandMonitoringCards = () => {
  const isRestorationProject = useIsRestorationProject();

  if (isRestorationProject) {
    return (
      <>
        <Stack spacing={8} className='md:flex-row'>
          <HabitatIntactnessCard />
          <NDVITile />
        </Stack>
        <Stack spacing={8} className='md:flex-row'>
          <WaterTile /> <CarbonTile />
        </Stack>
      </>
    );
  }
  return (
    <Stack spacing={8} className='md:flex-row'>
      <HabitatIntactnessCard />
      <IndicatorSpeciesCard />
    </Stack>
  );
};

const LandMonitoringExplainer = () => {
  const project = useProject();
  const { t } = useTranslation();

  const isVNUProject = project?.natureUnitVariant === ConservationMethodology.vnu;
  const isRestorationProject = useIsRestorationProject();

  if (isVNUProject) {
    return (
      <EcologicalIntegrityExplainerVNU
        trigger={
          <ExplainerTrigger buttonVariant='outline'>{t('global.measurementExplainer.buttonLabel')}</ExplainerTrigger>
        }
      />
    );
  }

  if (isRestorationProject) {
    return <RestorationLandMonitoringExplainer />;
  }

  return <EcologicalIntegrityExplainerBU />;
};
